export const LocalStorageKeys = {
	token: 'token',
	accessToken: 'accessToken',
	refreshToken: 'refreshToken',
	id: 'id',
	preferredLocale: 'preferredLocale',
	wasPwaModalSuggested: 'wasPwaModalSuggested',
	workoutRedirectURL: 'workoutRedirectURL',
}
